import React from 'react';
import PropTypes from 'prop-types';
import less from './LookingForwardToCooperation.less';
import account from '@/common/account/index';
import whichEnvironment from '@/common/utils/whichEnvironment';

class LookingForwardToCooperation extends React.Component {
  render() {
    function linkPaas() {
      const loginEd = account.hasLoggedin();
      const env = whichEnvironment();
      if (loginEd) {
        if (env === 'RELEASE') {
          window.open(
            'https://openai.100tal.com/console/manage/homepage',
            '_blank'
          );
        } else {
          window.open(
            'https://gateway-test-multi.facethink.com/console/manage/homepage',
            '_blank'
          );
        }
      } else {
        window.open('/account/login', '_blank');
      }
    }
    return (
      <div className={less.lookingForwardToCooperation}>
        <p className={less.title}>全线产品持续开放，期待与您合作</p>
        <p className={less.desc}>
          现在注册，免费使用好未来所有开放能力，让你的应用更了解教育
        </p>
        <div className={less.buttonOuter}>
          {this.props.freeTrial && this.props.freeTrial.show && (
            <button
              type="button"
              className={less.button + ' ' + less.freeTrialBtn}
              onClick={() => linkPaas()}
            >
              {this.props.freeTrial.button}
            </button>
          )}
          {this.props.technDocu && this.props.technDocu.to && (
            <button
              type="button"
              className={less.button + ' ' + less.technDocuBtn}
              onClick={() => window.open(this.props.technDocu.to)}
            >
              {this.props.technDocu.button}
            </button>
          )}
          {this.props.cooperationConsulting &&
            this.props.cooperationConsulting.to && (
              <button
                type="button"
                className={less.button + ' ' + less.freeTrialBtn}
                onClick={() => window.open(this.props.cooperationConsulting.to)}
              >
                {this.props.cooperationConsulting.button}
              </button>
            )}
        </div>
      </div>
    );
  }
}

LookingForwardToCooperation.propTypes = {
  freeTrial: PropTypes.shape({
    to: PropTypes.string,
    button: PropTypes.string
  }),
  technDocu: PropTypes.shape({
    to: PropTypes.string,
    button: PropTypes.string
  })
};

export default LookingForwardToCooperation;
